class SimpleSlider extends SliderComponent {
  constructor() {
    super();
    this.nav = this.querySelector('.collection-tabs');
    this.pill = this.nav?.querySelector('.collection-tabs__pill');
    this.navItems = this.nav ? this.nav.querySelectorAll('.collection-tab__link') : [];
    this.enableSliderLooping = true;
    this.lockNavSync = false;
    this.activeCollectionId = null;
    this.navSyncTimeout = null;

    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', (event) => this.onButtonClick(event, -1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (event) => this.onButtonClick(event, 1));
    }

    this.navItems.forEach((navItem) => {
      navItem.addEventListener('click', (event) => {
        event.preventDefault();
        const collectionId = navItem.dataset.collectionId;
        this.selectCollectionById(collectionId);
      });
    });

    this.slider = this.querySelector('.slider');
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.sliderItemOffset = this.sliderItems[0]?.offsetWidth || 0;

    if (this.slider) {
      this.slider.addEventListener('scroll', () => this.updateActiveNavFromScroll(), { passive: true });
    }
    window.addEventListener('resize', () => {
      this.sliderItemOffset = this.sliderItems[0]?.offsetWidth || 0;
      this.updateSliderHeight();
      this.updatePillPosition(true);
    });

    const initialActive = this.nav?.querySelector('.collection-tab__link.active');
    if (initialActive) {
      this.activeCollectionId = initialActive.dataset.collectionId;
    }

    this.updateSliderHeight();
    requestAnimationFrame(() => this.updatePillPosition(true));
  }

  lockNavDuringScroll(duration = 450) {
    this.lockNavSync = true;
    clearTimeout(this.navSyncTimeout);
    this.navSyncTimeout = setTimeout(() => {
      this.lockNavSync = false;
    }, duration);
  }

  selectCollectionById(collectionId) {
    const targetSlide = Array.from(this.sliderItems).find(
      (slide) => slide.dataset.collection === collectionId
    );
    if (!targetSlide) return;

    this.lockNavDuringScroll();
    this.updateActiveNavItem(collectionId);
    this.setSlidePosition(targetSlide.offsetLeft);
    this.updateSliderHeight();
    this.dispatchEvent(
      new CustomEvent('collection-change', {
        bubbles: true,
        detail: { collectionId: String(collectionId) },
      })
    );
  }

  updateActiveNavFromScroll() {
    if (this.lockNavSync || !this.sliderItemOffset) return;

    const activeIndex = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
    const activeCollectionId = this.sliderItems[activeIndex]?.dataset?.collection;
    if (activeCollectionId) this.updateActiveNavItem(activeCollectionId);
    this.updateSliderHeight();
  }

  updateActiveNavItem(activeCollectionId) {
    if (this.activeCollectionId === String(activeCollectionId)) return;

    this.activeCollectionId = String(activeCollectionId);
    this.navItems.forEach((item) => {
      const isActive = item.dataset.collectionId === this.activeCollectionId;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.updatePillPosition();
  }

  updatePillPosition(instant = false) {
    if (!this.pill || !this.nav) return;

    const activeLink = this.nav.querySelector('.collection-tab__link.active');
    if (!activeLink) return;

    const tab = activeLink.closest('.collection-tab') || activeLink;
    const width = Math.round(tab.offsetWidth);
    const offsetLeft = Math.round(tab.offsetLeft);

    if (instant) {
      this.pill.style.transition = 'none';
    }

    this.pill.style.width = `${width}px`;
    this.pill.style.transform = `translate3d(${offsetLeft}px, 0, 0)`;

    if (instant) {
      // Force reflow, then restore transition for later clicks
      void this.pill.offsetWidth;
      this.pill.style.transition = '';
    }
  }

  onButtonClick(event, direction) {
    event.preventDefault();
    const stepSize = direction * this.sliderItemOffset;
    let newPosition = this.slider.scrollLeft + stepSize;

    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

    if (newPosition < 0) {
      newPosition = maxScrollLeft;
    } else if (newPosition > maxScrollLeft) {
      newPosition = 0;
    }

    this.lockNavDuringScroll();

    const targetIndex = Math.round(newPosition / this.sliderItemOffset);
    const targetCollectionId = this.sliderItems[targetIndex]?.dataset?.collection;
    if (targetCollectionId) this.updateActiveNavItem(targetCollectionId);

    this.setSlidePosition(newPosition);

    setTimeout(() => {
      this.updateButtonStates();
    }, 450);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth',
    });
  }

  updateButtonStates() {
    if (!this.prevButton || !this.nextButton) return;
    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
    this.prevButton.disabled = !this.enableSliderLooping && this.slider.scrollLeft <= 0;
    this.nextButton.disabled = !this.enableSliderLooping && this.slider.scrollLeft >= maxScrollLeft;
  }

  updateSliderHeight() {
    const activeIndex = Math.round(this.slider.scrollLeft / this.sliderItemOffset);
    const activeSlide = this.sliderItems[activeIndex];
    if (activeSlide) {
      // this.slider.style.height = `${activeSlide.offsetHeight}px`;
    }
  }
}

customElements.define('simple-slider-component', SimpleSlider);
